<div class="modal-body">
  <p class="font-weight-500">{{ restaurant.address }} {{ restaurant.localityDisplay }}</p>
  <p class="font-weight-500">Location is permanently closed</p>
  <button class="btn btn-danger btn-block" (click)="onRemoveClick()">I confirm</button>
</div>
